// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"1c4e5c00","496":"75c7843f"}[chunkId] + ".chunk.js";
};